import { jsx as _jsx } from "react/jsx-runtime";
import { TranslationHtmlWrapper } from "../../components/TranslationHtmlWrapper/TranslationHtmlWrapper";
import { useConfig } from "../../providers/useConfig";
import { useTranslations } from "../../providers/useTranslations";
import { AlertBanner } from "../AlertBanner";
export const ExistingAccount = () => {
    const { __ } = useTranslations();
    const config = useConfig();
    return (_jsx(AlertBanner, { variant: "info", withVariantIcon: true, title: __("existing_account.title"), description: _jsx(TranslationHtmlWrapper, { text: "existing_account.text", htmlData: [config.AUTH_PAGE_URL, config.RESET_PAGE_URL] }), withIconClose: false }));
};
//# sourceMappingURL=ExistingAccount.js.map